import LegalPage from "@/pages/legal/components/LegalPage";
import { termsConditions } from "@/mocks/legal";

export default function Page() {
  return <LegalPage data={termsConditions} />;
}